import { FundingOption } from '@varo/graphql-schema-types';
import { useFundingCallback } from 'features/onboarding/hooks/useFundingCallback';
import React from 'react';
import WalletPaySuccess from 'shared/patterns/walletPay/screens/WalletPaySuccess/WalletPaySuccess';

const ApplePaySuccess = () => {
  const { hasCallback, invokeCallback } = useFundingCallback(
    FundingOption.ApplePay,
  );
  const handleSuccess = hasCallback
    ? () => {
        invokeCallback({ success: true });
      }
    : undefined;

  return (
    <WalletPaySuccess
      analytics={{
        screenKey: 'onboarding/apple-pay/apple-pay-success',
        eventName: 'Apple Pay Funding Completed',
        category: 'apple_pay',
        flowName: 'apple_pay_funding',
      }}
      onSuccess={handleSuccess}
      skipAutoNavigate={hasCallback}
    />
  );
};

export default ApplePaySuccess;
